module.exports = __webpack_public_path__ + "static/media/mod_cod4_surf_1.104f074d.jpg";